import { Box, Input, InputGroup, InputRightAddon, InputRightElement, VStack, useToast } from '@chakra-ui/react';
import { useWSysHub, useWSysPage } from "@coimbra-its/websys-ux-core";
import { useEffect, useState } from 'react';
import { SunBlock, SunButton, SunPage, SunValue, dispYearMonth, extractReadableError, extractTxError, formatAmount } from "../components/Sun";
import { SunState, useSunStore } from '../store/sunSlice';
import { payout_address } from '../web3/config';

export function Payout() {
    const page = useWSysPage({ title: 'Payout', maxCols: 2 });

    const hub = useWSysHub();

    const connectedWallet = useSunStore((state: SunState) => state.connectedWallet);
    const loadBalance = useSunStore((state: SunState) => state.loadBalance);
    const USDTBalance = useSunStore((state: SunState) => state.walletAmounts.USDTBalance);
    const USDTApprovedLimit = useSunStore((state: SunState) => state.walletAmounts.USDTApprovedLimit);

    const [lastDate, setLastDate] = useState(0);
    const [lastDatePaid, setLastDatePaid] = useState(false);
    const [nextDate, setNextDate] = useState(0);
    const [amountStr, setAmountStr] = useState('0');
    const [amount, setAmount] = useState(0);
    useEffect(() => {
        setAmount((parseFloat(amountStr) || 0) * 1e18)
    }, [amountStr]);

    const doLoad = async () => {
        hub.tryCatch(async () => {
            try {

                if (!connectedWallet)
                    throw 'Wallet not connected';

                const lastDateEnable = Number(await connectedWallet.PayoutContract.lastDate());
                setLastDate(lastDateEnable);

                const paidM = await connectedWallet.PayoutContract.paidMonths(BigInt(lastDateEnable));
                setLastDatePaid(paidM);

                if (!paidM) {
                    setNextDate(0);
                } else {

                    const lastYear = Math.floor(lastDateEnable / 100);
                    const lastMonth = lastDateEnable - 100 * lastYear;
                    let nextMonth = lastMonth + 1;
                    let nextYear = lastYear;
                    if (nextMonth > 12) {
                        nextMonth -= 12;
                        nextYear++;
                    }
                    setNextDate(nextYear * 100 + nextMonth);
                }
            } catch (ex) {
                throw extractReadableError(ex);
            }



        })
    }

    useEffect(() => {
        if (connectedWallet)
            doLoad();
    }, [connectedWallet])


    const doApprove = async () => {
        hub.tryCatch(async () => {
            try {
                if (!connectedWallet)
                    throw 'Wallet not connected';

                let value = BigInt(amount);

                // Végrehajtjuk az approve metódust
                const tx = await connectedWallet.USDTContract.approve(payout_address, value);

                // Várunk a tranzakció megerősítésére
                const receipt = await tx.wait();

                // Tranzakció hash kiírása
                console.log('Transaction hash:', receipt.hash);

                await loadBalance();
            } catch (ex) {
                throw extractReadableError(ex);
            }
        });

    }

    const doPayout = async () => {
        hub.tryCatch(async () => {

            try {

                if (!connectedWallet)
                    throw 'Wallet not connected';

                if (!nextDate || amount < 0)
                    return;

                // Végrehajtjuk az approve metódust
                const tx = await connectedWallet.PayoutContract.addDateAndAmount(BigInt(nextDate), BigInt(amount));

                // Várunk a tranzakció megerősítésére
                const receipt = await tx.wait();

                // Tranzakció hash kiírása
                console.log('Transaction hash:', receipt.hash);

                await loadBalance();
                await doLoad();

            } catch (ex) {
                throw extractReadableError(ex);
            }

        });

    }




    const toast = useToast();
    const doSyncNew = async () => {
        hub.tryCatch(async () => {
            try {

                const resp = await fetch("https://token.sdbn3.com:25003/api/sdbn1/sync_balances", { method: 'POST' })
                //const resp = await fetch("http://localhost:25003/api/sdbn1/sync_balances", {method:'POST'});
                const response = await resp.json();
                if (response.publicMessage)
                    throw response.publicMessage;
                else if (!resp.ok)
                    throw 'Failed to fetch'



                await loadBalance();
                await doLoad();
                toast({ status: 'success', description: 'Synchronization success' })

            } catch (ex) {
                throw extractReadableError(ex);
            }
        });


    }



    return <SunPage page={page} hubs={[hub]}>

        <VStack alignItems='stretch' justifyContent='center' h='100%' gap={9} px='4em'>
            {connectedWallet && <>
                <SunBlock header='Last date'>
                    <SunValue dim={lastDatePaid ? 'Paid' : 'Not paid'}>
                        {dispYearMonth(lastDate)}
                    </SunValue>
                </SunBlock>
                <SunBlock header='Next date'>
                    <SunValue>
                        {nextDate
                            ? dispYearMonth(nextDate)
                            : 'Last date is not ready!'
                        }
                    </SunValue>
                </SunBlock>
                <SunBlock header='Your balance'>
                    <SunValue dim='USDT'>{formatAmount(USDTBalance)}</SunValue>
                </SunBlock>
                <SunBlock header='Approved limit'>
                    <SunValue dim='USDT'>{formatAmount(USDTApprovedLimit)}</SunValue>
                </SunBlock>
                <SunBlock header='Payout amount' py={3}>
                    <InputGroup>
                        <Input
                            value={amountStr} onChange={e => setAmountStr(e.target.value)}
                            border='none' textAlign='right'
                        />
                        <InputRightAddon>USDT</InputRightAddon>
                    </InputGroup>
                </SunBlock>

                <SunBlock display='flex' flexDir='row' justifyContent='space-evenly' alignItems='center' py={3}>
                    <SunButton
                        isDisabled={!lastDatePaid || amount <= 0}
                        variant='black' onClick={doApprove}  >
                        1) Approve
                    </SunButton>
                    <SunButton
                        isDisabled={!lastDatePaid || amount <= 0 || Number(USDTApprovedLimit) < amount}
                        onClick={doPayout}>
                        2) Pay
                    </SunButton>
                </SunBlock>

                <SunBlock py={3} flexDir='column'>
                    <Box p={3} textAlign='center'>
                        {lastDatePaid
                            ? `Last date (${dispYearMonth(lastDate)}) is synchronized`
                            : `Last date (${dispYearMonth(lastDate)}) is NOT synchronized`
                        }
                    </Box>
                    <SunButton onClick={doSyncNew} isDisabled={lastDatePaid} >3) Synchronize</SunButton>
                </SunBlock>


            </>}
        </VStack>

    </SunPage>
}